import { type TimeLocale } from "helpers/AppProvider.types";

import { formatDate } from "commonComponents/utilities/DateDisplay/DateDisplay";

export function getLogTitle(
    builderTimeLocale: TimeLocale,
    logTitle: string | undefined,
    logDate: moment.Moment,
): string {
    const logTitleDisplay = logTitle !== "" ? ` | ${logTitle}` : "";
    return `${formatDate(logDate, builderTimeLocale, {
        showDate: true,
        showTime: false,
        showDayOfWeek: true,
        showMonth: true,
        showYear: true,
        hideCurrentYear: true,
    })} ${logTitleDisplay}`;
}
